export const globalLoadingMask = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_GLOBAL_LOADING_MASK':
      return !state
    case 'GLOBAL_LOADING_MASK_ON':
      return true
    case 'FETCH_CREDENTIALS_START':
    case 'FETCH_CREDENTIALS_SUCCESS':
    case 'FETCH_ENTITLEMENTS_START':
    case 'SET_CURRENT_SUPPORT_ACCOUNT_INDEX':
      return action.loading !== false
    case 'GLOBAL_LOADING_MASK_OFF':
      return false
    case 'SET_ENTITLED_APPS':
    case 'FETCH_ENTITLEMENTS_SUCCESS':
    case 'FETCH_CREDENTIALS_FAILURE':
    case 'FETCH_CREDENTIALS_NO_AUTH':
    case 'FETCH_ENTITLEMENTS_FAILURE':
      return action.loading === true
    default:
      return state
  }
}

// please be aware this reducer is overriden in hub for different message
// please keep in sync: globalLoadingOverride.js
export const globalLoadingMessage = (state = '', action) => {
  switch (action.type) {
    case 'GLOBAL_LOADING_MASK_OFF':
    case 'SET_ENTITLED_APPS':
    case 'FETCH_ENTITLEMENTS_SUCCESS':
    case 'FETCH_ENTITLEMENTS_FAILURE':
      return ''
    case 'SET_CURRENT_SUPPORT_ACCOUNT_INDEX':
      return 'Switching account...'
    case 'FETCH_CREDENTIALS_SUCCESS':
    case 'FETCH_ENTITLEMENTS_START':
      return 'Loading...' // APPORTAL-2274
    case 'SET_GLOBAL_LOADING_MASK_MSG':
      return action.message || ''
    default:
      return state
  }
}
